import * as Sentry from '@sentry/react'

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN

export function initSentry() {
  // Only initialize Sentry if DSN is provided
  if (!SENTRY_DSN) {
    console.warn('Sentry DSN not provided. Error tracking disabled.')
    return
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: import.meta.env.MODE,

    // Adds request headers and IP for users
    sendDefaultPii: true,

    integrations: [
      // Performance monitoring
      Sentry.browserTracingIntegration(),
      // Session replay for error debugging
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],

    // Set tracesSampleRate to 1.0 to capture 100% of transactions for tracing in development
    // Reduce this in production (e.g., 0.1 for 10%)
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,

    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    tracePropagationTargets: [
      'localhost',
      /^https:\/\/api\.careflow\.bg/,
      /^https:\/\/.*\.careflow\.bg/,
    ],

    // Capture Replay for 10% of all sessions in production, 100% in development
    // Plus 100% of sessions with an error
    replaysSessionSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
    replaysOnErrorSampleRate: 1.0,

    // Filter out non-critical errors
    beforeSend(event, hint) {
      const error = hint.originalException

      // Ignore ResizeObserver errors (common browser quirk)
      if (error instanceof Error && error.message.includes('ResizeObserver')) {
        return null
      }

      // Ignore canceled requests
      if (error instanceof Error && error.name === 'AbortError') {
        return null
      }

      return event
    },

    // Ignore certain URLs from performance monitoring
    ignoreTransactions: ['/health', '/healthcheck'],
  })
}

// Re-export Sentry for use in other parts of the app
export { Sentry }
